function WhySection({ title, items }) {
  const images = [
    '/why-location.jpg',
    '/gallery-staff.jpg',
    '/why-service.jpg',
    '/why-price.jpg',
  ];

  return (
    <section className="py-10 sm:py-[60px] bg-dark">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="font-playfair text-4xl sm:text-5xl font-bold" style={{ color: '#b9a1fc' }}>{title}</h2>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
          {items.map((item, i) => (
            <div key={i} className="group overflow-hidden rounded-lg" style={{ border: '1px solid #856ec7' }}>
              <div className="aspect-[4/3] overflow-hidden rounded-t-lg">
                <img
                  src={images[i] || images[0]}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  loading="lazy"
                />
              </div>
              <div className="p-3 sm:p-4 text-center">
                <p className="font-montserrat text-sm sm:text-base text-white/50 mb-1">{item.desc}</p>
                <h3 className="font-playfair text-base sm:text-lg font-bold" style={{ color: '#b9a1fc' }}>{item.title}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default WhySection;
